import { atom } from "recoil";

import { ICommand } from "@chainlit/react-client";

export interface IAttachment {
  id: string;
  serverId?: string;
  name: string;
  size: number;
  type: string;
  uploadProgress?: number;
  uploaded?: boolean;
  cancel?: () => void;
  remove?: () => void;
}

export const attachmentsState = atom<IAttachment[]>({
  key: "Attachments",
  default: [],
});

export const persistentCommandState = atom<ICommand | undefined>({
  key: "PersistentCommand",
  default: undefined,
});
